import { lazyRetry } from '@cast/utils';

import { useConnectClusterDialog } from '@oneclick/features/connect-cluster/useConnectClusterDialog';

const SplitMeOrganizationOverviewPage = lazyRetry(
  () => import('pages-op/overview/OrganizationOverviewPage')
);

export const OrganizationOverviewPage = () => {
  const { openConnectClusterDialog } = useConnectClusterDialog();

  return (
    <SplitMeOrganizationOverviewPage
      showDiscoverClusters={false}
      onConnectCluster={() => openConnectClusterDialog()}
    />
  );
};
